import styles from '../PropertyPanel.module.css';

const KEY_LABELS = {
  paddingTop: 'Top', paddingRight: 'Right', paddingBottom: 'Bottom', paddingLeft: 'Left',
  marginTop: 'Top', marginRight: 'Right', marginBottom: 'Bottom', marginLeft: 'Left',
  fontSize: 'Font Size', borderRadius: 'Radius', maxWidth: 'Max Width', alignSelf: 'Align',
};

function SpacingField({ label, values, onChange, keys }) {
  return (
    <div className={styles.field}>
      <span className={styles.fieldLabel}>{label}</span>
      <div className={styles.spacingGrid}>
        {keys.map((key) => (
          <label key={key} className={styles.spacingItem}>
            <span className={styles.spacingLabel}>{KEY_LABELS[key] || key}</span>
            <input
              type="text"
              className={styles.spacingInput}
              value={values[key] || ''}
              onChange={(e) => onChange(key, e.target.value)}
              placeholder="0"
            />
          </label>
        ))}
      </div>
    </div>
  );
}

export default SpacingField;
